import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SubjectTypeService } from 'app/shared/services/subject-type.service';

@Component({
  selector: 'app-mail-merge-wizard',
  templateUrl: './mail-merge-wizard.component.html',
  styleUrls: ['./mail-merge-wizard.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MailMergeWizardComponent implements OnInit {
  title = 'Mail Merge';
  intro =
    'Please select the subjects to be used when performing the mail merge:';
  wizard: UntypedFormGroup;
  subjects: any[];
  taskTypeEmailOrLetter: Number;
  peopleSubjects: any[];
  subjectTypes: any[];
  confirm = '';

  constructor(
    public dialogRef: MatDialogRef<MailMergeWizardComponent>,
    private subjectTypeService: SubjectTypeService,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.subjects = data.subjects;
    this.peopleSubjects = data.peopleSubjects;
    this.taskTypeEmailOrLetter = data.taskTypeEmailOrLetter;
    this.subjectTypes = [];
    this.confirm =
      this.taskTypeEmailOrLetter === 2 ? 'SEND EMAIL' : 'CREATE DOCUMENTS';
  }

  ngOnInit() {
    // get the unique available subject types in the list of subjects passed...
    const subjectTypeIds =
      this.peopleSubjects.length > 0
        ? Array.from(
            new Set(
              this.subjects
                .map((item: any) => item.subjectTypeId)
                .filter(
                  (id) => this.subjectTypeService.getName(id) !== 'Person'
                )
            )
          )
        : Array.from(
            new Set(this.subjects.map((item: any) => item.subjectTypeId))
          );

    // group data
    subjectTypeIds.forEach((subjectTypeId) => {
      // const filter = this.subjects.filter((subject: any) => subject.subjectTypeId === subjectTypeId);
      const subjectTypeGroup = {
        name: this.subjectTypeService.getName(subjectTypeId),
        subjects: this.subjects
          .filter((subject: any) => subject.subjectTypeId === subjectTypeId)
          .map((item: any) => {
            return {
              id: item.uid,
              name: item.summary,
              relationship: item.relationship,
            };
          }),
      };
      this.subjectTypes.push(subjectTypeGroup);
      if (this.peopleSubjects.length) {
        this.subjectTypes.filter((subjectType) => subjectType.name != 'Person');
      }
    });
    // tslint:disable-next-line:only-arrow-functions
    this.subjectTypes.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });

    // build form array
    const controls = this.formBuilder.array([]);
    this.subjectTypes.forEach((subjectType) => {
      const hasMany = subjectType.subjects.length > 1;
      const val =
        subjectType.subjects.length > 0 ? subjectType.subjects[0].id : '';
      controls.push(
        this.formBuilder.control({ value: val, disabled: !hasMany })
      );
    });

    // create form
    this.wizard = this.formBuilder.group({
      subjectTypes: controls,
    });
  }

  confirmSubmit() {
    const subjectUIDList: string[] = this.wizard.getRawValue().subjectTypes;
    if (this.peopleSubjects.length) {
      this.peopleSubjects.forEach((value) => subjectUIDList.push(value));
    }
    this.dialogRef.close({
      subjectUIDList,
    });
  }
}
